import axios from './axios'
export default {
  getSettings: function(campaignId) {
    return axios.get(
      `/${process.env.VUE_APP_API_VERSION}/campaigns/${campaignId}/settings/proof`
    )
  },
  saveSettings: function(campaignId, settings) {
    return axios.post(
      `/${process.env.VUE_APP_API_VERSION}/campaigns/${campaignId}/settings/proof`,
      { data: settings }
    )
  },
  saveAppearance: function(campaignId, settings) {
    return axios.post(
      `/${process.env.VUE_APP_API_VERSION}/campaigns/${campaignId}/appearance/proof`,
      { data: settings }
    )
  }
}
